import { NetworkRequestError } from './api-error';

// The app's error reporter, Sentry's `captureException` as main.tsx provides
// it through the router context.
export type ReportError = (
  error: unknown,
  context: { readonly tags: Readonly<Record<string, string>> },
) => void;

// A failed request the page degrades past instead of showing. A request that
// got no HTTP answer (`NetworkRequestError`) is not reported per occurrence:
// a crawler whose robots rules keep it off /api/ produces one on every visit,
// and a visitor's own outage is not actionable one visit at a time (a kept
// server body reports one that outlasts its recovery, sampled). A 5xx or an
// unexpected error is the API or the app failing, so it is reported.
export function reportRequestFailure(
  reportError: ReportError,
  error: unknown,
  tags: Readonly<Record<string, string>>,
): void {
  if (error instanceof NetworkRequestError) return;
  reportError(error, { tags });
}
